/**
 * The ARIA label for the week number cell (the first cell in the row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelWeekNumber(weekNumber, options) {
    return `Week ${weekNumber}`;
}
//# sourceMappingURL=labelWeekNumber.js.map